import { render, staticRenderFns } from "./miniProfileComponent.vue?vue&type=template&id=3ccd204a&"
import script from "./miniProfileComponent.vue?vue&type=script&lang=js&"
export * from "./miniProfileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports